import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FixedSizeList as List } from "react-window";
import AddressBookUtil from '../utils/AddressBookUtil';
import { DialogType, countries, LinkCorporationStatusType, DifferenceType, WarningAddressType, AddressType } from '../../../constants/ComponentTypes';
import { validateHouseAddressItem, validateWarningAddressItem, validateHouseAddressProperty, validateFollowCallAddressProperty, numHyphen } from '../../../utils/validator';
import { formatPostcode, formatErrorMessage } from '../../../utils/utils';
import DialogModal from '../../common/DialogModal';
import * as Messages from '../../../constants/Messages';
import Button from '../../Parts/Button';
import Loader from '../../Parts/Loader';
import TextField from 'material-ui/TextField';
import { FormControl, FormControlLabel } from 'material-ui/Form';
import MenuItem from 'material-ui/Menu/MenuItem';
import Select from 'material-ui/Select';
import Radio, { RadioGroup } from 'material-ui/Radio';
import Typography from 'material-ui/Typography';
import MuiButton from 'material-ui/Button';
import Toolbar from 'material-ui/Toolbar';
import { DialogTitle } from 'material-ui/Dialog';

import { InputLabel } from 'material-ui/Input';
import ChipInput from '../../common/ChipInput';
import Tooltip from 'material-ui/Tooltip';
import NotificationBar from '../../Parts/NotificationBar.jsx'
import CorporationSuggestion from './CorporationSuggestion';
import HelpIcon from '../../Icons/HelpIcon';
import Exclamation from '../../Icons/Exclamation';

const styles = () => ({
  paper: {
    maxHeight: 'unset',
    background: "#F4F6F9",
    width: '960px',
    minWidth: '1000px',
  },

  contentContainer: {
    margin: '0px',
    padding: '20px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  detailContentContainer: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    textAlign: 'left',
    position: 'relative',
    boxSizing: 'border-box',
  },

  content: {
    padding: '20px 25px',
    width: '100%',
    boxSizing: 'border-box',
  },

  form: {
    background: '#FFFFFF',
    border: '1px solid #D8DBDF',
    padding: '20px',
    width: '100%',
    boxSizing: 'border-box',
  },

  sectionTitle: {
    fontSize: '13px',
    background: '#F4F6F9',
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
  },

  row: {
    marginTop: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  input: {
    boxSizing: 'border-box',
  },

  tooltip: {
    backgroundColor: '#d32f2f',
    width: '100%',
    maxWidth: '335px',
  },

  left: {
    width: 'calc(50% - 10px)',
    marginRight: '20px',
  },

  right: {
    width: 'calc(50% - 10px)',
  },

  fullWidth: {
    width: '100%',
  },

  group: {
    marginTop: '16px',
    flexDirection: 'row',
  },

  formControlLabel: {
    fontSize: '15px',
    color: '#181819',
  },

  corporateNumContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #D8DBDF',
  },

  corporateNum: {
    flex: 1,
    background: "#F4F6F9",
    color: "#B1B3B9",
    padding: '12px 15px',
    fontSize: '15px',
  },

  corporateNumTitle: {
    background: "#FFFFFF",
    fontSize: '15px',
    color: "#181819",
    padding: '12px 15px',
    borderRight: '1px solid #D8DBDF',
  },

  noCorporateNumContainer: {
    width: '100%',
    background: 'rgb(26, 101, 255, 0.05)',
    color: "#181819",
    padding: '18px 20px',
  },

  noCorporateSuggestionContainer: {
    width: '100%',
    background: '#F4F6F9',
    color: "#71737B",
    fontSize: '15px',
    padding: '30px',
    textAlign: 'center',
    marginTop: '15px',
    position: 'relative',
  },

  corporationListContainer: {
    width: '100%',
    background: '#F4F6F9',
    marginTop: '15px',
    padding: '30px',
    position: 'relative',
    '&:before': {
      content: '""',
      width: '100%',
      height: '100%',
      position: 'absolute',
      left: 0,
      top: 0,
      pointerEvents: 'none',
      background: 'linear-gradient(transparent 450px, white 100%)'
    }
  },

  corporationList: {
    width: '100%',
    marginTop: '10px',
    maxHeight: '500px',
    overflow: 'scroll',
  },

  linkBtn: {
    border: 'none',
    minWidth: 'unset',
    width: 'unset',
    minHeight: 'unset',
    height: 'unset',
    padding: '0px 5px',
    marginTop: '5px',
    fontSize: '11px',
    color: '#1A65FF',
    textDecoration: 'underline',
  },

  linkBtn2: {
    border: 'none',
    minWidth: 'unset',
    width: 'unset',
    minHeight: 'unset',
    height: 'unset',
    padding: '0px 5px',
    fontSize: '13px',
    color: '#1A65FF',
  },

  link: {
    textDecoration: 'underline',
    fontSize: '13px',
    color: '#71737B',
    marginLeft: '10px',
  },

  subRow: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },

  arrow: {
    position: 'absolute',
    fontSize: 6,
    bottom: 0,
    left: 'calc(50% - 1.5em)',
    marginBottom: '-0.95em',
    width: '3em',
    height: '1em',

    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '1em 1em 0 1em',
      borderColor: `#181819 transparent transparent transparent`,
    },
  },

  tooltipHelp: {
    fontSize: 13,
    maxWidth: 340,
    backgroundColor: "#181819",
    padding: '12px 15px',
    opacity: 1,
  },

  gutters: {
    background: "#FFFFFF",
    fontSize: "15px",
    fontWeight: 700,
    borderBottom: "1px solid #D8DBDF",
    width: '100%',
    boxSizing: 'border-box',
  },

  dialogTitle: {
    padding: '0px',
    flex: 1,
  },

  textRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  warningInput: {
    border: '1px solid #D6B330 !important'
  },

  salesforceLabel: {
    background: "#FFF3C6",
    border: "1px solid #D6B330",
    borderRadius: "2px",
    opacity: 1,
    padding: '8px 14px',
    boxSizing: 'border-box',
    fontSize: '11px',
    fontWeight: 'bold',
    color: '#484848'
  }
});

const linkCorporationSuccess = 2
class EditAddressDialog extends React.Component {
  state = {
    item: AddressBookUtil.makeAddress(this.props.item ? this.props.item : {}),
    warning: this.props.type === DialogType.ERROR || this.props.type === DialogType.WARNING || this.props.type === DialogType.WARNING_DETAIL ? validateWarningAddressItem(this.props.item) : {},
    error: this.props.type === DialogType.ERROR || this.props.type === DialogType.WARNING || this.props.type === DialogType.WARNING_DETAIL ? validateHouseAddressItem(this.props.item, this.props.isFollowCallAddress) : {},
    errorMessage: '',
    saveBtnPressed: this.props.type === DialogType.ERROR || this.props.type === DialogType.WARNING || this.props.type === DialogType.WARNING_DETAIL,
    linkCorporation: (!this.props.item || !!this.props.item.link_corporation_status) ? true : false,
    showCorporationSuggestions: this.props.item && this.props.item.link_corporation_status === linkCorporationSuccess ? false : true,
    showMessage: true,
    showVerificationMessage: {
      COMPANY_NAME: true,
      ADDRESS: true,
      CLOSE: true,
    }
  }

  componentWillMount() {
    this.getAddressSuggestCorporations();

    this.setState({
      linkCorporation: this.getLinkCorporation(this.props),
      showCorporationSuggestions: this.getShowCorporationSuggestions(this.props),
    })
  }

  componentWillReceiveProps(nextProps) {
    //close dialog when API succeeds
    if (this.props.isDeleting && nextProps.isDeleting === false) {
      nextProps.toggleDialog();
    }

    if (this.props.isSaving && nextProps.isSaving === false) {
      if (nextProps.error && nextProps.error.data && nextProps.error.data.warning_addresses.length > 0) {
        nextProps.toggleDialog(nextProps.error.data.warning_addresses[0]);
      } else if (typeof nextProps.error === 'string') {
        this.setState({
          errorMessage: nextProps.error,
        })
      } else {
        nextProps.toggleDialog();
      }
    }

    if (this.props.isUpdatingDifferences && nextProps.isUpdatingDifferences === false) {
      document.body.style.cursor = "auto";
      nextProps.toggleDialog();
    }

    if (this.props.isUpdatingDifferences === false && nextProps.isUpdatingDifferences) {
      document.body.style.cursor = "progress";
    }
  }

  getLinkCorporation = (props) => {
    if (props.type === DialogType.EDIT) {
      return props.item && !!props.item.link_corporation_status;
    } else if (props.type === DialogType.WARNING || props.type === DialogType.ERROR || props.type === DialogType.WARNING_DETAIL) { //会社名あれば、デフォルトは法人番号を紐付けする
      return props.item && !!props.item.company;
    } else {
      return true;
    }
  }

  getShowCorporationSuggestions = (props) => {
    if (props.type === DialogType.EDIT) {
      return props.item && props.item.link_corporation_status === LinkCorporationStatusType.LINK_SUCCESS ? false : true;
    } else if (props.type === DialogType.CREATE) {
      return true;
    } else {
      if (props.item && props.item.detail && props.item.detail["corporate_number"]) {
        return false;
      } else {
        return true;
      }
    }
  }

  getCorporateNumber = (item) => {
    if (item) {
      if (this.props.type === DialogType.EDIT) {
        return item.corporation ? item.corporation.corporate_number : '';
      } else if (this.props.type === DialogType.WARNING ||
        this.props.type === DialogType.ERROR ||
        this.props.type === DialogType.WARNING_DETAIL) {
        if (item && item.corporate_number) {
          return item.corporate_number;
        } else if (item && item.detail && item.detail.corporate_number) {
          return item.detail.corporate_number;
        }
      }
    }

    return '';
  }

  handleChange = property => e => {
    let item = this.state.item;
    let value;

    if (property === 'link_corporation') {
      this.setState({ linkCorporation: e.target.value === 'true' });
      if (e.target.value === 'true') {
        if (this.state.item.corporation !== null) {
          item['link_corporation_status'] = LinkCorporationStatusType.LINK_SUCCESS;
        } else {
          item['link_corporation_status'] = LinkCorporationStatusType.LINK_FAILURE;
        }
      } else {
        item['link_corporation_status'] = LinkCorporationStatusType.NOT_LINK;
      }
      return;
    }

    if (property === 'tags') {
      if (Array.isArray(e)) {
        value = e;
      } else {
        return;
      }
    } else {
      value = e.target.value;
    }

    if (property === "post_code"
      || property === "tel"
      || property === "fax") {
      value = numHyphen(value);
    }
    item[property] = value;

    // ２回目からタイピングごとでチェック
    if (this.state.saveBtnPressed) {
      this.validateInput(property, value);
    }

    this.setState({
      item: item,
    })
  }

  handleClose = () => {
    const isSalesforceItem = (this.props.type === DialogType.EDIT &&
      this.props.item &&
      this.props.item.type === AddressType.SALESFORCE.value);

    if (isSalesforceItem ||
      this.countEditedItems() === 0 ||
      window.confirm(Messages.ADDRESS_UNSAVED)) {
      this.props.toggleDialog();
    }
  }

  handleSave = () => {
    if (!this.state.saveBtnPressed) this.validateForm();

    this.setState({
      errorMessage: '',
      saveBtnPressed: true,
    }, () => {
      if (this.countErrors() === 0) {
        let item = this.state.item;

        if (this.props.type === DialogType.EDIT) {
          item["corporation_id"] = item["corporation"] && item["link_corporation_status"] === LinkCorporationStatusType.LINK_SUCCESS ? item["corporation"].id : null;
        }

        item["is_follow_call_address"] = this.props.isFollowCallAddress;
        this.props.save([item], this.props.type, this.props.isFollowCallAddress, this.state.linkCorporation)
      }
    });
  }

  handleDelete = () => {
    this.props.delete(this.state.item);
    this.props.toggleDialog();
  }

  handleLinkCorporation = (corporation, value) => {
    if (this.props.type === DialogType.EDIT) {
      let item = { ...this.state.item };
      if (value) {
        item["corporation"] = corporation;
        item["link_corporation_status"] = LinkCorporationStatusType.LINK_SUCCESS;
      } else {
        item["corporation"] = null;
        item["link_corporation_status"] = LinkCorporationStatusType.LINK_FAILURE;
      }
      this.setState({
        item: item,
      })
    } else if (this.props.type === DialogType.ERROR || this.props.type === DialogType.WARNING || this.props.type === DialogType.WARNING_DETAIL) {
      let item = { ...this.state.item };

      if (value) {
        item["link_corporation"] = this.state.linkCorporation;
        item["corporate_number"] = corporation.corporate_number;
      } else {
        item["link_corporation"] = this.state.linkCorporation;
        delete item["corporate_number"];
      }

      this.setState({
        item: item,
      })
    }
  }

  // バリデーションをレター送付アドレスかフォローコールアドレスかに応じて実行
  validateAddressProperty = (value, item, p) => {
    if (this.props.isFollowCallAddress) {
      return validateFollowCallAddressProperty(value, item, p);
    } else {
      return validateHouseAddressProperty(value, item, p);
    }
  }

  validateInput = (p, value) => {
    let { item, error, warning } = this.state;

    //clear error before update
    if (error.hasOwnProperty(p)) delete error[p];
    if (!this.props.isFollowCallAddress) {
      // フォローコールアドレスの場合は会社名、名前は必須なのでエラーを削除しない
      if (p === "name" || p === "company") {
        delete error["name"];
        delete error["company"];
      }
    }

    //update error
    let err = this.validateAddressProperty(value, item, p);
    error = Object.assign({}, error, err);

    //update warning
    warning = validateWarningAddressItem(item);

    this.setState({
      error: error,
      warning: warning,
    });
  }

  validateForm = () => {
    let { item, error, warning } = this.state;

    error = validateHouseAddressItem(item, this.props.isFollowCallAddress);
    warning = validateWarningAddressItem(item);

    this.setState({
      error: error,
      warning: warning,
    });
  };

  getAddressSuggestCorporations = (company, address) => {
    let data = {};
    if (company) {
      data["company"] = company;
    }

    if (address) {
      data["address"] = address;
    }

    if (this.props.type === DialogType.EDIT) {
      this.props.getAddressSuggestCorporations(this.props.item.id, data);
    } else if (this.props.type === DialogType.WARNING || this.props.type === DialogType.WARNING_DETAIL) {
      this.props.getWarningAddressSuggestCorp(this.props.item.id, data);
    } else if (this.props.type === DialogType.ERROR) {
      this.props.getErrorAddressSuggestCorp(this.props.item.id, data);
    }
  }

  handleFocus = () => {
    this.addressOnFocus = this.state.item["address"];
    this.companyOnFocus = this.state.item["company"];
  }

  handleBlur = () => {
    if (this.props.type !== DialogType.CREATE && this.props.item) {
      if (this.state.item["company"] !== this.companyOnFocus ||
        this.state.item["address"] !== this.addressOnFocus) {
        this.getAddressSuggestCorporations(this.state.item["company"], this.state.item["address"]);
      }
    }
  }

  countEditedItems = () => {
    let initValue = AddressBookUtil.makeAddress(this.props.item ? this.props.item : {});
    let count = 0;
    let item = this.state.item;

    for (let property in initValue) {
      if (property === "id") continue;

      if (property === "tags") {
        if (JSON.stringify(item[property]) !== JSON.stringify(initValue[property])) count++;
      } else if (property === "corporation") {
        if (item[property] === null && initValue[property] === null) {
          continue;
        } else if (item[property] === null || initValue[property] === null) {
          count++;
        } else if (item[property].id !== initValue[property].id) {
          count++;
        }
      } else {
        if (item[property] !== initValue[property]) count++;
      }
    }

    return count;
  }

  countErrors = () => {
    return Object.keys(this.state.error).length;
  }

  countWarnings = () => {
    return Object.keys(this.state.warning).length;
  }

  toggleCorporationSuggestions = () => {
    this.setState({
      showCorporationSuggestions: !this.state.showCorporationSuggestions,
    })
  }

  handleUpdate = (type, id) => () => {
    let message = ''
    switch (type) {
      case DifferenceType.COMPANY_NAME:
        message = '会社名を更新します。よろしいですか？';
        break;
      case DifferenceType.ADDRESS:
        message = '住所を更新します。よろしいですか？';
        break;
      case DifferenceType.CLOSE:
        message = 'アドレス帳から削除します。よろしいですか？';
        break;
      default:
    }
    if (window.confirm(message)) {
      this.props.postAddressCorporationDifferencesUpdateDifference({ "id": id });
    }
  }

  renderErrorMessage = () => {
    const { classes, item } = this.props;

    let message, style;
    if ((this.state.saveBtnPressed && this.countErrors() > 0)) {
      message = "エラー項目を確認してください。";
      style = "error";
    } else if (this.state.errorMessage !== '') {
      message = this.state.errorMessage;
      style = "error";
    } else if ((this.props.type === DialogType.EDIT && this.state.saveBtnPressed && this.countWarnings() > 0) ||
      (this.props.type === DialogType.WARNING_DETAIL && this.props.item.type === WarningAddressType.CONTAINS_SYMBOL.value)) {
      message = "記号が含まれている項目を確認してください。問題ない場合はこのまま登録ボタンを押してメインボックスに登録できます。";
      style = "ghost";
    } else if (this.props.type === DialogType.EDIT
      && this.state.item
      && this.state.item.link_corporation_status === LinkCorporationStatusType.LINK_FAILURE) {
      message = "法人番号を紐づけることができませんでした。お手数ですが紐づける法人をご選択ください。";
      style = "ghost";
    } else if (this.props.type === DialogType.WARNING
      && this.props.item.type === WarningAddressType.INVALID_POSTCODE.value) {
      message = (
        <div className={classes.textRow}>
          <Exclamation width={15} height={15} color="#71737B" style={{ marginRight: '5px' }} />
          {WarningAddressType.INVALID_POSTCODE.text}
          {/* 一時的に非活動化 */}
          <MuiButton
            color="primary"
            className={this.props.classes.linkBtn2}
            onClick={this.handleDelete}>
            アドレスを削除
          </MuiButton>
        </div>
      )
      style = "ghost";
    } else if (this.props.type === DialogType.WARNING
      && this.props.item.type === WarningAddressType.INVALID_ADDRESS_REPEATING_PATTERNS.value) {
      message = (
        <div className={classes.textRow}>
          <Exclamation width={15} height={15} color="#71737B" style={{ marginRight: '5px' }} />
          {item && item.detail && item.detail.error ? item.detail.error : WarningAddressType.INVALID_ADDRESS_REPEATING_PATTERNS.text}
          {/* 一時的に非活動化 */}
          <MuiButton
            color="primary"
            className={this.props.classes.linkBtn2}
            onClick={this.handleDelete}>
            アドレスを削除
          </MuiButton>
        </div>
      )
      style = "ghost";
    } else if (this.props.type === DialogType.WARNING
      && this.props.item.type === WarningAddressType.INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA.value) {
      message = (
        <div className={classes.textRow}>
          <Exclamation width={15} height={15} color="#71737B" style={{ marginRight: '5px' }} />
          {item && item.detail && item.detail.error ? item.detail.error : WarningAddressType.INVALID_ADDRESS_NOT_MATCHING_POSTCODE_DATA.text}
          {/* 一時的に非活動化 */}
          <MuiButton
            color="primary"
            className={this.props.classes.linkBtn2}
            onClick={this.handleDelete}>
            アドレスを削除
          </MuiButton>
        </div>
      )
      style = "ghost";
    } else if (this.props.type === DialogType.ERROR) {
      let error = this.props.item.detail && this.props.item.detail.error ? this.props.item.detail.error : {};
      message = formatErrorMessage({ data: { message: error } });
      style = "error";
    }

    if (message) {
      return (
        <NotificationBar
          message={message}
          type={style}
          open={true}
          autoClose={false}
          disableOnclickListener={true}
          style={{ transform: 'none', boxShadow: 'none', width: '100%', boxSizing: 'border-box', marginBottom: '20px' }}
        >
        </NotificationBar>
      )
    }
  }

  renderVerificationMessage = () => {
    const { classes } = this.props;

    if (this.props.type === DialogType.EDIT
      && this.props.item
      && this.props.item.address_corporation_differences
      && this.props.item.address_corporation_differences.length > 0) {


      return this.props.item.address_corporation_differences.map((d, i) => {
        let m1, m2, rows = [], prop;
        let corporate_number = this.props.item.corporation && this.props.item.corporation.corporate_number;

        switch (d.type) {
          case DifferenceType.COMPANY_NAME:
            m1 = "会社名が登記簿上で変更されました。アドレス帳の情報も更新しますか？";
            m2 = `[新会社名] ${d.new_company} (変更事由: ${d.reason})`;
            prop = 'COMPANY_NAME';
            break;
          case DifferenceType.ADDRESS:
            m1 = "登記簿上の住所が変更されました。アドレス帳の情報も更新しますか？";
            m2 = `[新住所] ${formatPostcode(d.new_post_code)} ${d.new_address} (変更事由: ${d.reason})`
            prop = 'ADDRESS';
            break;
          case DifferenceType.CLOSE:
            m1 = "登記簿上で閉鎖が確認されました。アドレス帳から削除しますか？";
            m2 = `閉鎖事由: 登記記録の閉鎖等 (変更事由: ${d.reason})`
            prop = 'CLOSE';
            break;
          default:
            break;
        }

        let rowOne = (
          <div className={classes.textRow} style={{ borderBottom: '1px solid #D8DBDF' }}>
            {m1}
            <MuiButton
              color="primary"
              className={this.props.classes.linkBtn2}
              onClick={this.handleUpdate(d.type, d.id)}>
              {d.type === DifferenceType.CLOSE ? "削除" : "更新する"}
            </MuiButton>
          </div>
        );

        let rowTwo = (
          <div
            className={classes.textRow}
            style={{
              fontWeight: 200,
            }}>
            {m2}
            {corporate_number && (
              <a className={classes.link} target="_blank" href={`https://www.houjin-bangou.nta.go.jp/henkorireki-johoto.html?selHouzinNo=${corporate_number}`}>さらに詳しく</a>
            )}
          </div>
        );

        rows.push(rowOne);
        rows.push(rowTwo);

        return (
          <NotificationBar
            key={i}
            message={rows}
            type="ghost"
            open={true}
            onHandleClose={() => this.setState({ showVerificationMessage: { ...this.state.showVerificationMessage, [prop]: false } })}
            autoClose={false}
            disableOnclickListener={true}
            style={{
              display: this.state.showVerificationMessage[prop] ? 'flex' : 'none',
              transform: 'none',
              boxShadow: 'none',
              width: '100%',
              boxSizing: 'border-box',
              marginBottom: '20px',
              padding: '0px 20px'
            }}
          >
          </NotificationBar>
        )
      })
    } else if (this.props.type === DialogType.WARNING && this.props.item.type === WarningAddressType.ADDRESS_LENGTH.value) {
      let rows = [];

      let rowOne = (
        <div className={classes.textRow} style={{ borderBottom: '1px solid #D8DBDF' }}>
          <Exclamation width={15} height={15} color="#71737B" style={{ marginRight: '5px' }} />
          住所に脱字の可能性が検出されました
          {/* 一時的に非活動化 */}
          <MuiButton
            color="primary"
            className={this.props.classes.linkBtn2}
            onClick={this.handleDelete}>
            アドレスを削除
          </MuiButton>
          <div
            style={{
              borderLeft: "1px solid #D8DBDF",
              marginLeft: '5px',
              paddingRight: '5px',
              height: '15px',
            }}
          ></div>
          <MuiButton
            color="primary"
            className={this.props.classes.linkBtn2}
            onClick={this.handleSave}
          >
            メインボックスに登録
          </MuiButton>
        </div>
      );

      let rowTwo = (
        <div
          className={classes.textRow}
          style={{
            fontWeight: 200,
          }}>
          郵便番号から取得した住所と比較し、脱字の可能性を検出しました
        </div>
      );

      rows.push(rowOne);
      rows.push(rowTwo);

      return (
        <NotificationBar
          message={rows}
          type="ghost"
          open={true}
          onHandleClose={() => this.setState({ showMessage: false })}
          autoClose={false}
          disableOnclickListener={true}
          style={{
            display: this.state.showMessage ? 'flex' : 'none',
            transform: 'none',
            boxShadow: 'none',
            width: '100%',
            boxSizing: 'border-box',
            marginBottom: '20px',
            padding: '0px 20px'
          }}
        >
        </NotificationBar>
      )
    }
  }

  renderCorporationForm = () => {
    const { classes } = this.props;
    let isExecAddress = (this.props.item && this.props.item.relocation_personnel_users && this.props.item.relocation_personnel_users.address_registed_at !== null);

    return (
      <div className={classes.row}>
        <FormControl fullWidth disabled={!this.state.item["company"]}>
          <div className={classes.flex} style={{ alignItems: 'center' }}>
            <Tooltip
              placement="top"
              title={
                <React.Fragment>
                  国税庁が公開している法人番号を自動で紐づけることができます。また、送付NGを正確に弾くためには法人番号が必須です。※名称や住所等のデータには一切影響しません。
                  <span className={classes.arrow} />
                </React.Fragment>
              }
              classes={{
                tooltip: classes.tooltipHelp,
              }}
            >
              <InputLabel shrink={true} disableAnimation={true} style={{ display: 'inline-flex', alignItems: 'center', position: isExecAddress ? 'unset' : 'absolute' }}>
                法人番号
                <div>
                  <HelpIcon width={15} height={15} color="#71737B" />
                </div>
              </InputLabel>
            </Tooltip>
          </div>
          {(() => {
            if (!isExecAddress) {
              return (
                <RadioGroup
                  aria-label="gender"
                  name="gender2"
                  className={classes.group}
                  value={this.state.linkCorporation.toString()}
                  onChange={this.handleChange("link_corporation")}
                >
                  <FormControlLabel
                    value="true"
                    control={<Radio color="primary" />}
                    label="紐づける(推奨)"
                    classes={{ label: classes.formControlLabel }} />
                  <FormControlLabel
                    value="false"
                    control={<Radio color="primary" />}
                    label="紐付けない"
                    classes={{ label: classes.formControlLabel }} />
                </RadioGroup>
              )
            }
          })()}
        </FormControl>
      </div>
    )
  }

  renderCorporationDetail = () => {
    const { classes } = this.props;
    const { item } = this.state;
    let isExecAddress = (this.props.item && this.props.item.relocation_personnel_users && this.props.item.relocation_personnel_users.address_registed_at !== null);

    if (this.props.type !== DialogType.CREATE && this.state.linkCorporation) {
      return (
        <div className={classes.row} style={{ marginTop: '0px', flexDirection: 'column' }}>
          <div className={classes.subRow}>
            <div className={classes.corporateNumContainer}>
              <div className={classes.corporateNumTitle}>法人番号</div>
              <div className={classes.corporateNum}>{this.getCorporateNumber(item)}</div>
            </div>
          </div>
          {(() => {
            if (!isExecAddress) {
              return (
                <div className={classes.subRow}>
                  <MuiButton
                    color="primary"
                    className={classes.linkBtn}
                    onClick={this.toggleCorporationSuggestions}>
                    {this.state.showCorporationSuggestions ? "法人番号候補を非表示" : "法人番号候補を表示"}
                  </MuiButton>
                </div>
              )
            }
          })()}
        </div>
      )
    }
  }

  renderCorporationSuggestions = () => {
    const { classes, isLoadingCorp, corporations } = this.props;

    const maxCount = 5;
    const maxCountHeight = 500;
    const unitHeight = 100;
    const unitAddHeight = 20;

    if (this.props.type !== DialogType.CREATE && this.state.linkCorporation && this.state.showCorporationSuggestions) {
      if (isLoadingCorp) {
        return (
          <div className={classes.row} style={{ marginTop: '0px' }}>
            <div className={classes.noCorporateSuggestionContainer}>
              <Loader type="color" size="large" />
            </div>
          </div>
        )
      } else if (this.props.corporations && this.props.corporations.length > 0) {
        return (
          <div className={classes.row} style={{ marginTop: '0px' }}>
            <div className={classes.corporationListContainer}>
              <div className={classes.subRow}>
                <Typography variant="body2" style={{ flex: 1, fontWeight: "bold", color: "#71737B" }}>もしかして？</Typography>
                <Typography variant="body2" style={{ color: "#71737B" }}>{corporations.length}件が該当しました</Typography>
              </div>
              <div className={classes.corporationList}>
                {(() => {
                  const Row = ({ index, style, data }) => {
                    const corporation = data[index];

                    return (
                      <div style={style}>
                        <CorporationSuggestion
                          key={index}
                          corporation={corporation}
                          isLinked={this.getCorporateNumber(this.state.item) === corporation.corporate_number}
                          handleLinkCorporation={this.handleLinkCorporation}
                        />
                      </div>
                    )
                  };

                  return (
                    <List
                      className="List"
                      height={corporations.length > maxCount ? maxCountHeight : corporations.length * unitHeight + unitAddHeight}
                      itemCount={corporations.length}
                      itemData={corporations}
                      itemSize={100}
                      width={"100%"}
                    >
                      {Row}
                    </List>
                  )
                })()}
              </div>
            </div>
          </div>
        )
      } else {
        return (
          <div className={classes.row} style={{ marginTop: '0px' }}>
            <div className={classes.noCorporateSuggestionContainer}>
              法人番号が見つかりませんでした。会社名に誤字脱字がないか確認してください。
            </div>
          </div>
        )
      }
    }
  }

  render() {
    const { classes, isSaving, isDeleting, isOpen, title, type } = this.props;
    const { error, item, warning } = this.state;

    const isSalesforceItem = (type === DialogType.EDIT &&
      item &&
      this.props.item.type === AddressType.SALESFORCE.value);

    return (
      <DialogModal
        title={isSalesforceItem ? "" : title}
        open={isOpen}
        onClose={this.handleClose}
        maxWidth={false}
        classes={{
          contentContainer: classes.detailContentContainer,
          paper: classes.paper,
        }}
      >

        {type === DialogType.WARNING_DETAIL &&
          (<Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              警告の詳細
            </DialogTitle>

            <Button
              text="削除"
              type="ghost"
              handleClickButton={this.handleDelete}
              size="small"
              loading={isDeleting}
              style={{ marginRight: '10px' }}
            />

            <Button
              text="メインボックスに登録"
              handleClickButton={this.handleSave}
              loading={isSaving}
              disabled={this.countErrors() > 0}
              size="small"
            />
          </Toolbar>)
        }

        {isSalesforceItem &&
          (<Toolbar classes={{ gutters: classes.gutters }}>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              アドレスを編集
            </DialogTitle>

            <span className={classes.salesforceLabel}>
              このデータはSalesforceレコードです。Salesforceで編集してください。
            </span>
          </Toolbar>)
        }

        <div className={classes.content}>
          {this.renderErrorMessage()}
          {this.renderVerificationMessage()}

          <div
            className={classes.form}>
            <div
              className={classes.formInner}
              style={{ pointerEvents: isSalesforceItem ? 'none' : 'auto' }}>
              <div className={classes.row}>
                <div className={classes.sectionTitle}>名称</div>
              </div>

              <div className={classes.row}>
                <div className={classes.fullWidth}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["company"] ? error["company"] : ""}
                  >
                    <TextField
                      id="company"
                      value={item["company"]}
                      label="会社名"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("company") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="会社名を入力"
                      onChange={this.handleChange("company")}
                      onFocus={this.handleFocus}
                      onBlur={this.handleBlur}
                      error={error.hasOwnProperty("company")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>

              {this.renderCorporationForm()}
              {this.renderCorporationDetail()}
              {this.renderCorporationSuggestions()}

              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["branch"] ? error["branch"] : ""}
                  >
                    <TextField
                      id="branch"
                      value={item["branch"]}
                      label="支店・部署"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("branch") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="支店・部署を入力"
                      onChange={this.handleChange("branch")}
                      error={error.hasOwnProperty("branch")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>

                <div className={classes.right}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["position"] ? error["position"] : ""}
                  >
                    <TextField
                      id="position"
                      value={item["position"]}
                      label="役職"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("position") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="役職を入力"
                      onChange={this.handleChange("position")}
                      error={error.hasOwnProperty("position")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["name"] ? error["name"] : ""}
                  >
                    <TextField
                      id="name"
                      value={item["name"]}
                      label="氏名"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("name") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="氏名を入力"
                      onChange={this.handleChange("name")}
                      error={error.hasOwnProperty("name")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>

                <div className={classes.right}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["honorific"] ? error["honorific"] : ""}
                  >
                    <TextField
                      id="honorific"
                      value={item["honorific"]}
                      label="敬称"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("honorific") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="敬称を入力"
                      onChange={this.handleChange("honorific")}
                      error={error.hasOwnProperty("honorific")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.sectionTitle}>住所</div>
              </div>

              <div className={classes.row}>
                <div className={classes.left}>
                  <FormControl
                    error={error.hasOwnProperty("country_id")}
                    fullWidth
                  >
                    <InputLabel>国</InputLabel>
                    <Select
                      value={item['country_id']}
                      onChange={this.handleChange("country_id")}
                      classes={{ select: classes.input }}
                      disableUnderline={true}
                      error={error.hasOwnProperty("country_id") || warning.hasOwnProperty("country_id")}
                      disabled={isSalesforceItem}
                    >
                      {Object.values(countries).map(
                        (c, k) => (<MenuItem key={k} value={c.ISO}>{c.name}</MenuItem>))}
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.right}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["post_code"] ? error["post_code"] : ""}
                  >
                    <TextField
                      id="post_code"
                      value={item["post_code"]}
                      label="郵便番号"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("post_code") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="郵便番号を入力"
                      onChange={this.handleChange("post_code")}
                      error={error.hasOwnProperty("post_code")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.fullWidth}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["address"] ? error["address"] : ""}
                  >
                    <TextField
                      id="address"
                      value={item["address"]}
                      label="住所"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("address") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="住所を入力"
                      onChange={this.handleChange("address")}
                      onFocus={this.handleFocus}
                      onBlur={this.handleBlur}
                      error={error.hasOwnProperty("address")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>
              {this.props.isFollowCallAddress && (
                <Typography variant="body2">
                  ※住所が入力されない場合、名前と会社名で重複チェックを行います。
                </Typography>
              )}
              <div className={classes.row}>
                <div className={classes.sectionTitle}>その他</div>
              </div>

              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["tel"] ? error["tel"] : ""}
                  >
                    <TextField
                      id="tel"
                      value={item["tel"]}
                      label="電話番号"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("tel") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="電話番号を入力"
                      onChange={this.handleChange("tel")}
                      error={error.hasOwnProperty("tel")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>

                <div className={classes.right}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["fax"] ? error["fax"] : ""}
                  >
                    <TextField
                      id="fax"
                      value={item["fax"]}
                      label="FAX番号"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("fax") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="FAX番号を入力"
                      onChange={this.handleChange("fax")}
                      error={error.hasOwnProperty("fax")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>
              </div>

              <div className={classes.row}>
                <div className={classes.left}>
                  <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    placement="top-start"
                    title={error["email"] ? error["email"] : ""}
                  >
                    <TextField
                      id="email"
                      value={item["email"]}
                      label="メールアドレス"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          input: warning.hasOwnProperty("email") ? classes.warningInput : undefined
                        }
                      }}
                      InputLabelProps={{ shrink: true, }}
                      placeholder="メールアドレスを入力"
                      onChange={this.handleChange("email")}
                      error={error.hasOwnProperty("email")}
                      className={classes.input}
                      disabled={isSalesforceItem}
                      fullWidth
                    />
                  </Tooltip>
                </div>

                <div className={classes.right}>
                  <FormControl
                    error={error.hasOwnProperty("tags")}
                    fullWidth
                  >
                    <InputLabel shrink={true} disableAnimation={true}>リスト</InputLabel>
                    <ChipInput
                      id="tags"
                      chips={item["tags"]}
                      onChange={this.handleChange("tags")}
                      placeholder="任意のリスト名を入力してください"
                      className={classes.input}
                      disabled={isSalesforceItem}
                      style={{ marginTop: '16px' }}
                    />
                  </FormControl>
                </div>
              </div>
            </div>
            {(!isSalesforceItem && type !== DialogType.WARNING_DETAIL) && <div className={classes.row}>
              <Button
                text="保存"
                handleClickButton={this.handleSave}
                loading={isSaving}
                disabled={this.countErrors() > 0}
                style={{ marginTop: '20px', marginBottom: '40px' }}
              />
            </div>}

            {isSalesforceItem && <div className={classes.row}>
              <Button
                text="閉じる"
                handleClickButton={this.props.toggleDialog}
                style={{ marginTop: '20px', marginBottom: '40px' }}
              />
            </div>}
          </div>
        </div>
      </DialogModal>
    );
  }
}

EditAddressDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  save: PropTypes.func.isRequired,
  delete: PropTypes.func,
  item: PropTypes.object,
  title: PropTypes.string,
  type: PropTypes.number,
  isSaving: PropTypes.bool,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  postAddressLinkCorporation: PropTypes.func,
  getAddressSuggestCorporations: PropTypes.func,
  getWarningAddressSuggestCorp: PropTypes.func,
  getErrorAddressSuggestCorp: PropTypes.func,
  corporations: PropTypes.array,
  isLoadingCorp: PropTypes.bool,
  isDeleting: PropTypes.bool,
  isFollowCallAddress: PropTypes.bool,
  isUpdatingDifferences: PropTypes.bool,
  postAddressCorporationDifferencesUpdateDifference: PropTypes.func,
};

EditAddressDialog.defaultProps = {
  isFollowCallAddress: false
}

export default withStyles(styles)(EditAddressDialog);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/EditAddressDialog.jsx